import { mapGetters } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import ConfiguracaoAtendimentoHorario from "@/models/configuracaoAtendimentoHorarioModel";
import ConfiguracaoAtendimentoModel from "@/models/configuracaoAtendimentoModel";
import TipoHorarioAtendimento from "@/models/enum/TipoHorarioAtendimento";
import FranquiaModel from "@/models/franquiaModel";
import UsuarioModel from "@/models/usuarioModel";
import ConfiguracaoUsuarioAtendimentoModel from "@/models/whatsApp/configuracaoUsuarioAtendimentoModel";
import ConfiguracaoAtendimentoService from "@/services/configuracaoAtendimentoService";
import UsuarioService from "@/services/usuarioService";
import { Getters } from "@/store/store";

import EditComponentBase from "../editComponentBase";

import "../crud.scss";

@Component({
    components: {
        gridComponent,
        comboComponent,
        fieldsetComponent,
        buttonIncluirComponent,
        actionBarComponent,
        checkboxComponent,
    },
    computed: {
        ...mapGetters(["GET_FRANQUIA_ATUAL"] as Getters),
    },
})
export default class ConfiguracaoAtendimentoEditComponent extends EditComponentBase<ConfiguracaoAtendimentoModel> {
    // State computed props
    GET_FRANQUIA_ATUAL: () => FranquiaModel;

    horarioInicioString: string = null;
    horarioFimString: string = null;
    tipoHorario = 0;
    perfilUsuarioAtendimento = 0;
    ativoAlocacaoAutomatica = true;
    usuarioId = 0;
    usuarioOptions: Array<Object> = [];

    tipoAlocacaoAtendimentoOptions: Array<Object> = [
        { text: "Manual", value: 1 },
        { text: "Fila", value: 2 },
        // { text: "FilaOnline", value: 3 },
    ];

    perfilUsuarioAtendimentoOptions: Array<Object> = [
        { text: "Administrador", value: 1 },
        { text: "Atendente", value: 2 },
    ];

    tiposOptions: Array<Object> = [
        { text: "Semanal", value: TipoHorarioAtendimento.Semanal },
        { text: "Sábado", value: TipoHorarioAtendimento.Sabado },
        { text: "Domingo", value: TipoHorarioAtendimento.Domingo },
    ];

    gridColumnsUsuarios: Array<GridColumn> = [
        new GridColumn("usuarioDescricao", "Usuário", GridColumnType.String),
        new GridColumn("perfilUsuarioAtendimentoDescricao", "Perfil", GridColumnType.String),
        new GridColumn("ativoAlocacaoAutomatica", "Ativo Alocação Aut.", GridColumnType.Boolean),
    ];

    gridColumsHorarios: Array<GridColumn> = [
        new GridColumn("tipoDescricao", "Tipo", GridColumnType.String),
        new GridColumn("horarioInicioString", "Horário Inicio", GridColumnType.String),
        new GridColumn("horarioFimString", "Horário Fim", GridColumnType.String),
    ];

    private dateParaString(horario: Date): string {
        const horas = horario.getHours().toString().padStart(2, "0");
        const minutos = horario.getMinutes().toString().padStart(2, "0");
        return `${horas}:${minutos}`;
    }

    private clearConfigUsuarioForm() {
        this.ativoAlocacaoAutomatica = true;
        this.usuarioId = null;
        this.perfilUsuarioAtendimento = null;
    }

    private async onAdicionaUsuario() {
        const results = Promise.all([
            this.$validator.validate("usuarioId"),
            this.$validator.validate("perfilUsuarioAtendimento"),
        ]);

        const isValid = (await results).every(isValid => isValid);
        if (isValid) {
            if (this.model.configuracaoUsuarios.findIndex(u => u.usuarioId == this.usuarioId) != -1) {
                return this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.usuarioJaCadastrado"));
            }

            const configUsuario = new ConfiguracaoUsuarioAtendimentoModel();
            configUsuario.ativoAlocacaoAutomatica = this.ativoAlocacaoAutomatica;
            configUsuario.perfilUsuarioAtendimento = this.perfilUsuarioAtendimento;
            configUsuario.perfilUsuarioAtendimentoDescricao = this.perfilUsuarioAtendimentoOptions.find(
                item => item["value"] == this.perfilUsuarioAtendimento,
            )["text"];
            configUsuario.usuarioId = this.usuarioId;
            configUsuario.usuarioDescricao = this.usuarioOptions.find(item => item["value"] == this.usuarioId)["text"];

            this.model.configuracaoUsuarios.push(configUsuario);

            this.clearConfigUsuarioForm();
        }
    }

    private onRemoverUsuario(model: ConfiguracaoUsuarioAtendimentoModel) {
        this.model.configuracaoUsuarios = this.model.configuracaoUsuarios.filter(p => p != model);
    }

    private async onAdicionaHorario() {
        const results = Promise.all([
            this.$validator.validate("tipoHorario"),
            this.$validator.validate("horarioInicio"),
            this.$validator.validate("horarioFim"),
        ]);

        const isValid = (await results).every(isValid => isValid);
        if (isValid) {
            const hasAtendimento = this.model.configuracaoAtendimentoHorario.some(
                p =>
                    this.tipoHorario == p.tipo &&
                    ((this.horarioInicioString >= this.dateParaString(p.horarioInicio) &&
                        this.horarioInicioString < this.dateParaString(p.horarioFim)) ||
                        (this.tipoHorario == p.tipo &&
                            this.horarioFimString > this.dateParaString(p.horarioInicio) &&
                            this.horarioFimString <= this.dateParaString(p.horarioFim)) ||
                        (this.tipoHorario == p.tipo &&
                            this.horarioInicioString <= this.dateParaString(p.horarioInicio) &&
                            this.horarioFimString > this.dateParaString(p.horarioInicio) &&
                            this.horarioFimString <= this.dateParaString(p.horarioFim))),
            );

            if (!hasAtendimento) {
                const horario = new ConfiguracaoAtendimentoHorario();
                horario.tipo = this.tipoHorario;
                horario.tipoDescricao = this.tiposOptions.find(item => item["value"] == this.tipoHorario)["text"];

                horario.horarioInicio = new Date();
                horario.horarioInicioString = this.horarioInicioString;
                horario.horarioInicio.setHours(Number(this.horarioInicioString.split(":")[0]));
                horario.horarioInicio.setMinutes(Number(this.horarioInicioString.split(":")[1]));
                horario.horarioInicio.setSeconds(0, 0);

                horario.horarioFim = new Date();
                horario.horarioFimString = this.horarioFimString;
                horario.horarioFim.setHours(Number(this.horarioFimString.split(":")[0]));
                horario.horarioFim.setMinutes(Number(this.horarioFimString.split(":")[1]));
                horario.horarioFim.setSeconds(0, 0);

                this.model.configuracaoAtendimentoHorario.push(horario);

                this.model.configuracaoAtendimentoHorario.sort((a, b) => {
                    if (a.tipo < b.tipo) return -1;
                    if (a.tipo > b.tipo) return 1;

                    const horarioInicioA = new Date(a.horarioInicio).getTime();
                    const horarioInicioB = new Date(b.horarioInicio).getTime();

                    return horarioInicioA - horarioInicioB;
                });

                this.horarioInicioString = "";
                this.horarioFimString = "";
            } else {
                return this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.voceJaPossuiHorario"));
            }
        } else {
            this.$focusErrorField();
        }
    }

    private onRemover(model: ConfiguracaoAtendimentoHorario) {
        this.model.configuracaoAtendimentoHorario = this.model.configuracaoAtendimentoHorario.filter(p => p != model);
    }

    private padLeft(value: number) {
        const valueString = value.toString();
        return valueString.length == 1 ? "0" + valueString : valueString;
    }

    public async save() {
        try {
            const response = await this.service[!this.model["id"] ? "insert" : "update"](this.model)
                .withLoading()
                .resolveWithResponse();

            if (response.ok) {
                await this.$showInclusaoUpdate(this.model["id"]);

                this.$router.back();
            }

            return false;
        } catch {}
    }

    private async loadUsuario() {
        try {
            const data = await new UsuarioService()
                .listByFranquiaId(this.GET_FRANQUIA_ATUAL().id)
                .resolveWithJSON<UsuarioModel[]>();

            this.usuarioOptions = data.map(item => ({ value: item.id, text: item.nome }));
        } catch {}
    }

    public async afterMounted() {
        if (!this.usuarioLogado.franquia.moduloWhatsApp) {
            this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.franquiaNaoModuloContratado"));

            this.$router.back();
        }

        try {
            this.clearConfigUsuarioForm();
            await this.loadUsuario();

            const data = await new ConfiguracaoAtendimentoService()
                .getByFranquia()
                .withLoading()
                .resolveWithJSON<ConfiguracaoAtendimentoModel>();

            if (data) {
                data.configuracaoAtendimentoHorario = data.configuracaoAtendimentoHorario
                    .sort((a, b) => {
                        if (a.tipo < b.tipo) return -1;
                        if (a.tipo > b.tipo) return 1;

                        const horarioInicioA = new Date(a.horarioInicio).getTime();
                        const horarioInicioB = new Date(b.horarioInicio).getTime();

                        return horarioInicioA - horarioInicioB;
                    })
                    .map(p => {
                        const model = new ConfiguracaoAtendimentoHorario();
                        model.updateFrom(p);

                        const dateInicio = new Date(p.horarioInicio);
                        model.horarioInicioString = `${this.padLeft(dateInicio.getHours())}:${this.padLeft(
                            dateInicio.getMinutes(),
                        )}`;

                        const dateFim = new Date(p.horarioFim);
                        model.horarioFimString = `${this.padLeft(dateFim.getHours())}:${this.padLeft(
                            dateFim.getMinutes(),
                        )}`;

                        return model;
                    });
            }

            this.model.updateFrom(data);
        } catch {}
    }

    private async beforeMount() {
        await this.setProps(
            new ConfiguracaoAtendimentoService(),
            "configuracao_atendimento",
            new ConfiguracaoAtendimentoModel(),
        );
    }
}
